class BaseHttpService {
  constructor(client) {
    this.client = client
  }
}

export default BaseHttpService
